import { render, staticRenderFns } from "./previewPaper.vue?vue&type=template&id=6a307158&scoped=true"
import script from "./previewPaper.vue?vue&type=script&lang=js"
export * from "./previewPaper.vue?vue&type=script&lang=js"
import style0 from "./previewPaper.vue?vue&type=style&index=0&id=6a307158&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a307158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a307158')) {
      api.createRecord('6a307158', component.options)
    } else {
      api.reload('6a307158', component.options)
    }
    module.hot.accept("./previewPaper.vue?vue&type=template&id=6a307158&scoped=true", function () {
      api.rerender('6a307158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/curriculum-manage/previewPaper.vue"
export default component.exports